import { Button, Modal } from "antd";
import React, { useState } from "react";
import MyMap from "../Map";
import "./style.css";

const LocationModal = ({ open, setOpen, location, setLocation }) => {
  const [locationValue, setLocationValue] = useState(location);
  const handleLocationConfirm = () => {
    setLocation(locationValue);
    setOpen(false);
  };

  return (
    <Modal
      className="location-modal"
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <MyMap locationValue={location} setLocationValue={setLocationValue} />
      <Button
        className="button2-location-modal"
        onClick={() => handleLocationConfirm()}
      >
        Select
      </Button>
    </Modal>
  );
};

export default LocationModal;
